import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Space,
  Popconfirm,
  Form,
  Input,
  Upload,
  Spin,
  Alert,
  Avatar,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { usePartner } from "../contexts/PartnerContext";
import ScrollableTable from "../components/ScrollableTable";

const Partners: React.FC = () => {
  const {
    partners,
    loading,
    error,
    fetchPartners,
    createPartner,
    deletePartner,
  } = usePartner();

  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchPartners();
  }, []);

  const handleAdd = () => {
    form.resetFields();
    setModalVisible(true);
  };

  const handleDelete = async (id: string) => {
    await deletePartner(id);
  };

  const handleFinish = async (values: any) => {
    if (!values.image?.[0]?.originFileObj) {
      return;
    }

    await createPartner(values.name, values.image[0].originFileObj);
    setModalVisible(false);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (img: string) =>
        img && <Avatar shape="square" size={64} src={img} />,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: string) => date && new Date(date).toLocaleString(),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space>
          <Popconfirm
            title="Are you sure to delete this partner?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2>Partners</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Add Partner
        </Button>
      </div>
      {error && (
        <Alert type="error" message={error} style={{ marginBottom: 16 }} />
      )}
      <Spin spinning={loading} tip="Loading partners...">
        <ScrollableTable rowKey="id" columns={columns} dataSource={partners} />
      </Spin>
      <Modal
        open={modalVisible}
        title="Add Partner"
        onCancel={() => setModalVisible(false)}
        footer={null}
        forceRender={false}
        width={600}
      >
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            label="Name"
            name="name"
            rules={[
              { required: true, message: "Please enter the partner name" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Image"
            name="image"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
            rules={[{ required: true, message: "Please upload an image" }]}
          >
            <Upload
              beforeUpload={() => false}
              maxCount={1}
              listType="picture"
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>Upload Partner Image</Button>
            </Upload>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Create Partner
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Partners;
